import idx from "idx";

export const parseDate = ddMmYyyy => {
  let items = ddMmYyyy.split("/");

  if (items.length === 3) {
    return {
      d: items[0],
      m: items[1],
      y: items[2]
    };
  }

  return {};
};

export const twoDigits = value => Math.floor(value * 100) / 100;

export const isAndroidCloaca = process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && /provider.*IronTrade.*AndroidCloak/g.test(
  navigator.userAgent
);

export const isAndroid = () => {
  return /android \d\.\d/.test(navigator.userAgent.toLowerCase());
};

export const isWebKitWebViewIOSApp = () => {
  return /wkwebview/.test(navigator.userAgent.toLowerCase());
};

export const isIphone8 = () => {
  const lc = navigator.userAgent.toLowerCase();
  return /iphone os 8_\d/.test(lc) && /version\/8\.\d/.test(lc);
};

export const isVietnam = code => {
  return typeof code === "string" && code.toLowerCase() === "vn";
};

const androidAppRegExp = /\bos\b.*\bAndroidWeb\b.*\bapplication_id\b.*com\.full\.iron.*\bversion\b: (\d+).*\bprovider\b.*\bIronTrade\b.*wvbo_full/;
const ironTerminalIosAppRegExp = /\bprovider\b.*\bIronTrade\b.*\bos\b.*\biOS\b.*\bapplication_id\b.*com\.ironterminal\.ios.*\bversion\b: (\d+)/;
export const isAndroidApp = process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&  androidAppRegExp.test(navigator.userAgent);
export const androidAppVersion = (() => {
  if (process.env.REACT_APP_DEPLOY_TARGET !== "irontrade") return null;
  const r = androidAppRegExp.exec(navigator.userAgent);

  return r ? parseInt(r[1], 10) : null;
})();

export const isIronTerminalIosApp = process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && ironTerminalIosAppRegExp.test(
  window.navigator.userAgent
);

export function iOSAppPostMessage(message) {
  const wk = window.webkit;
  const mh = wk && wk.messageHandlers;
  const ch = mh && mh.callbackHandler;
  const pm = ch && typeof ch.postMessage === "function";
  if (pm) {
    ch.postMessage(message);
    return true;
  } else {
    console.log("postMessage is undefined");
    return false;
  }
}

export const isIronTerminal = () =>
  /ironterminal/.test(navigator.userAgent.toLowerCase());

export const supportEmail = (serverData, profile) => {
  if (serverData != null) {
    if (process.env.REACT_APP_DEPLOY_TARGET === "irontrade") {
      if (profile == null) {
        return (
          idx(
            serverData,
            d => d.supportInfoList.country[serverData.geo].email
          ) ||
          idx(serverData, d => d.supportInfoList.default.email) ||
          serverData.supportEmail
        );
      }

      return (
        idx(
          serverData,
          d => d.supportInfoList.currency[profile.currency].email
        ) ||
        idx(serverData, d => d.supportInfoList.default.email) ||
        serverData.supportEmail
      );
    } else {
      return (
        idx(serverData, d => d.supportInfoList.country[serverData.geo].email) ||
        idx(serverData, d => d.supportInfoList.default.email) ||
        serverData.supportEmail
      );
    }
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/components/utils.js